module.exports = __webpack_public_path__ + "img/probation.9619c4fc.png";